import { format as formatSats } from '../../lib/bsv-util'

// Below this an amount reads in sats; from here up, in dollars.
export const CARD_USD_MIN = 0.1

const SATOSHIS = 100000000

export type CardAmount = { label: string; unit: 'sats' | 'usd' }

// Every amount above zero shows: in sats under 10 cents (or while the rate is
// unknown), in dollars from there up. Null when there is nothing to show.
export function cardAmount(
    sats30d: number | null | undefined,
    exchangeRate: number | null,
): CardAmount | null {
    if (typeof sats30d !== 'number' || !Number.isFinite(sats30d) || sats30d <= 0) return null
    if (!exchangeRate || (sats30d / SATOSHIS) * exchangeRate < CARD_USD_MIN) {
        const whole = Math.round(sats30d)
        return { label: `${formatSats(whole)} ${whole === 1 ? 'sat' : 'sats'}`, unit: 'sats' }
    }
    return { label: formatCardUsd(sats30d, exchangeRate), unit: 'usd' }
}

// Dollar amounts always spell the cents ("$12.50", not the shared
// formatter's "$12.5").
export function formatCardUsd(sats: number, exchangeRate: number): string {
    const usd = (sats / SATOSHIS) * exchangeRate
    return `$${usd.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
}

// "128 members", "1.2K members"; a one-member channel reads "1 member".
export function formatMembersLabel(count: number | null | undefined): string | null {
    if (typeof count !== 'number' || !Number.isFinite(count) || count < 1) return null
    if (count === 1) return '1 member'
    if (count < 1000) return `${count} members`
    return `${(count / 1000).toFixed(1).replace(/\.0$/, '')}K members`
}
